const INITIAL_STATE = {
    transactions: null,
    error:null,
    loading: false,
    loaded: false
};

export default function(state = INITIAL_STATE, action) {
    let error;
    switch(action.type) {
        case "FETCH_BRANCH_TRANSACTIONS":
            return { ...state, transactions: null, error: null, loaded: false, loading: true};
        case "FETCH_BRANCH_TRANSACTIONS_SUCCESS":
            return { ...state, transactions: action.payload, error: null, loaded: true, loading: false};
        case "FETCH_BRANCH_TRANSACTIONS__FAILURE":
            error = action.payload || {message: action.payload.message};
            return { ...state, transactions: null, error: error, loading: false};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/transaction.js